import axios from 'axios';
import { API_URL } from '../../constants.js';

class PalletService {

    async exportPalletLabelPdf(model_number, quantity) {
        const url = `${API_URL}/export-pallet-label/${model_number}/${quantity}`;
        const headers = {
            'Content-Type': 'application/json',
        };

        return axios({
            url: url,
            method: 'get',
            responseType: 'blob',
            headers: headers,
        })
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response ? error.response.data : { error: 'Unknown error' };
        });
    }

    async previewPalletLabelPdf(model_number, quantity) {
        const url = `${API_URL}/preview-pallet-label/${model_number}/${quantity}/`;
        const headers = {
            'Content-Type': 'application/json',
        };

        return axios({
            url: url,
            method: 'get',
            headers: headers,
        })
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response ? error.response.data : { error: 'Unknown error' };
        });
    }
}

export default PalletService;